import Vue from "vue";

import "../styles/quasar.scss";
import lang from "quasar/lang/es.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import { Quasar, Loading, Notify, BottomSheet } from "quasar";

Vue.use(Quasar, {
  config: {
    loading: {
      spinnerColor: "primary"
    },
    Notify
  },
  components: {
    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  plugins: {
    Loading,
    Notify,
    BottomSheet
  },
  lang: lang,
  cssAddon: true
});
